<template>
    <el-pagination id="paging"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="pageNum"
        :page-sizes="[10, 30, 50, 100, 200]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next,jumper"
        :total="gopage"
        hide-on-single-page>
    </el-pagination>
</template>
<script>
export default {
    name:'paging',
    props:{
        gopage:Number
    },
    data(){
        return{
            pageNum:1,
            pageSize:10,
        }
    },
    created(){
    },
    mounted(){
    },
    methods:{
        handleSizeChange(val) {
            this.pageSize = val
            this.$emit('pag',{pageNum:this.pageNum,pageSize:val})
        },
        handleCurrentChange(val) {
            this.pageNum = val
            this.$emit('pag',{pageNum:val,pageSize:this.pageSize})
        },
    },
}
</script>
<style>
#paging .el-input__inner{
    margin: 0 !important
}
</style>